//https://imagekit.io/blog/how-to-resize-image-in-javascript/
import React, {memo, useEffect, useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import moment from "moment";
import {getOut, getprojectandmetadata, getToken} from "../../Utils/Common";
import TagesTatigVerortung from "./TagesTatigVerortung";
import TagesTaetigkeiten from "./TagesTaetigkeiten";
import {jsPDF} from "jspdf";
import "jspdf-autotable"
import "./Calibri-normal";
//import $ from "jquery";

import Select from 'react-select'
import AppCommonReportComponent from "../Stunden/AppCommonReportComponent";
import TagesButtonComponent from "./TagesButtonComponent";
import {font} from "../Stunden/Calibrifont";


function TagesberichtComponent(props) {
    const [pdfAddress,setPdfAddress]=useState(props.pdfAddress)
        const [tagesState, setTagesState] = useState(props.tageState)
    const [metaID,setMetaID]=useState(props.tagesID)
    const [auftraggeberList,setAuftraggeberList]=useState([])
    const [disablePDFButton, setDisablePDFButton] = useState(true)
    const [projectID, setProjectID] = useState(props.projectID)
    const [projectName, setProjectName] = useState("")
    const [reportobject, setreportobject] = useState({})
    const [oneDayDate, setOneDayDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [options, setOptions] = useState([])
    const [oneDayTickStatus, setOneDayTickStatus] = useState(false)
    const [reportselecttableonebody, setreportselecttableonebody] = useState(<></>);
    const [maintatigdataarray, setmaintatigdataarray] = useState([])
    const [pdfData, setPdfData] = useState([])
    const [reportView, setReportView] = useState(false)
    const [acceptState, setAcceptState] = useState(false)

    const [handleShow, setHandleShow] = useState(false)
    const [reportDetails, setReportDetails] = useState({})
    const [projectData, setProjectData] = useState({})
    const [metaData, setMetaData] = useState({})
    const [tagesComponents,setTagescomponents]=useState({})

    useEffect(async()=>{
        console.log(acceptState)
    },[acceptState])

    useEffect(async()=>{
        if (metaID!==""){
            let body = {
            token: getToken(),
            data: {
                dataID: metaID
            }
        };
            let res = await getprojectandmetadata(body)
        setProjectData(res.proj_data);
                    setPdfAddress(res.proj_data.auftraggeberAddress.firma + "\n" +
                res.proj_data.auftraggeberAddress.streetName + " " +
                res.proj_data.auftraggeberAddress.houseNumber + "\n" +
                res.proj_data.auftraggeberAddress.postalCode + " " +
                res.proj_data.auftraggeberAddress.cityName)

        setMetaData(res.meta_data);
        setProjectName(res.proj_data.projectName)
            let auftraggeberData = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/auftraggeberList", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify({token: getToken(), data: {projectID:res.proj_data.projectID}}),
        }).then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
            setAuftraggeberList(auftraggeberData.data)
        }

    },[metaID])



    useEffect(async () => {
        if (props?.reportView === true &&
            props?.reportViewWithoutLogin === false) {
            setReportView(true)
            await getsavedtagesreportdata({tagesID: props.details.dataID})
        } else if (props?.reportView !== true &&
            props?.reportViewWithoutLogin === true) {
            setReportView(true)
            await getsavedtagesreportdatawithoutlogin(props.details)
        } else {
            setReportView(false)
        }
    }, [props])


    useEffect(async () => {
        let apiBody = {
            "token": getToken(), "data": {
                "organisationID": sessionStorage.getItem("org")
            }
        }
        let listofProjects = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/readprojects", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
        if (listofProjects.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        } else {
            setOptions(listofProjects.data.map(a => ({"label": a.projectName, "value": a.projectID})))
        }


    }, [])


    useEffect(() => {
        console.log("checkprojectname")
    }, [projectName])


    async function getreportselectiontabledata(apiBody) {
        return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getreportselectiontabledata", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify({token: getToken(), data: apiBody}),
        }).then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    async function getcompletetagesreportdata(apiBody) {
        setTagescomponents(apiBody)
        let completeData = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/gettagesberichtcompletedata", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify({token: getToken(), data: apiBody, "projectName": projectName}),
        }).then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
        let tagestatigdataarray = completeData.data.tagestatigdataarray
        setmaintatigdataarray(tagestatigdataarray)
        let clonedArray = JSON.parse(JSON.stringify(tagestatigdataarray))

        let h = await modifydataforimage(clonedArray)
        setPdfData(h)
        if (clonedArray) {
            setDisablePDFButton(false)
        }


        let projectData = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getoneproject", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify({token: getToken(), data: {"projectID": projectID}}),
        }).then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
        setProjectData(projectData.project)
        setPdfAddress(projectData.project.auftraggeberAddress.firma + "\n" +
                projectData.project.auftraggeberAddress.streetName + " " +
                projectData.project.auftraggeberAddress.houseNumber + "\n" +
                projectData.project.auftraggeberAddress.postalCode + " " +
                projectData.project.auftraggeberAddress.cityName)
    }

    async function getsavedtagesreportdata(apiBody) {
        let completeData = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getTagesReport", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify({token: getToken(), data: apiBody}),
        }).then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })

        let body = {
            token: getToken(),
            data: {
                dataID: apiBody.tagesID
            }
        };
        let res = await getprojectandmetadata(body)
        setProjectData(res.proj_data);
                            setPdfAddress(res.proj_data.auftraggeberAddress.firma + "\n" +
                res.proj_data.auftraggeberAddress.streetName + " " +
                res.proj_data.auftraggeberAddress.houseNumber + "\n" +
                res.proj_data.auftraggeberAddress.postalCode + " " +
                res.proj_data.auftraggeberAddress.cityName)
        setMetaData(res.meta_data);
        setProjectName(res.proj_data.projectName)


        let tagestatigdataarray = completeData.data.report
        setmaintatigdataarray(tagestatigdataarray)
        let clonedArray = JSON.parse(JSON.stringify(tagestatigdataarray))
        let h = await modifydataforimage(clonedArray)
        setPdfData(h)
        if (clonedArray) {
            setDisablePDFButton(false)
        }

    }

    async function getsavedtagesreportdatawithoutlogin(dataarray) {
        setmaintatigdataarray(dataarray)
        let clonedArray = JSON.parse(JSON.stringify(dataarray))
        let h = await modifydataforimage(clonedArray)
        setPdfData(h)
        if (clonedArray) {
            setDisablePDFButton(false)
        }

    }


    function getImageDimensions(url) {
        return new Promise((resolve, reject) => {
            // Create a new Image object
            const img = new Image();

            // Set the image source to the provided URL
            img.src = url;

            // Define the callback function to be executed when the image is loaded
            img.onload = function () {
                // Resolve the promise with the image dimensions
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            };

            // Handle errors in case the image fails to load
            img.onerror = function (error) {
                // Reject the promise with an error object
                reject({
                    error: "Failed to load image",
                    details: error
                });
            };
        });
    }

    async function modifydataforimage(tagestatigdataarr) {
        let tagestatigdataarrayforpdf = tagestatigdataarr
        for (let i in tagestatigdataarrayforpdf) {

            let imagedata = tagestatigdataarrayforpdf[i].imagesdata
            for (let j in imagedata) {

                let timages = await Promise.all(
                    imagedata[j].tatigkeitenimages.map(async (image) => {
                        try {
                            if (!image.includes("https")) {
                                image=image.replace("http", "https")
                            }
                            const dimensions = await getImageDimensions(image);
                            return {
                                link: image,
                                ...dimensions
                            };
                        } catch (error) {
                            return {
                                error
                            };
                        }
                    })
                );
                imagedata[j].timageurls = timages

                let vimages = await Promise.all(
                    imagedata[j].tatigverortungimages.map(async (image) => {
                        try {
                            if (!image.includes("https")) {
                                image=image.replace("http", "https")
                            }
                            const dimensions = await getImageDimensions(image);
                            return {
                                link: image,
                                ...dimensions
                            };
                        } catch (error) {
                            return {
                                error
                            };
                        }
                    })
                );
                imagedata[j].vimageurls = vimages

            }
        }
        return tagestatigdataarrayforpdf
    }

    function preparereportselectiontabledata(tabledata) {
        return tabledata.data?.map((item) => (<tr key={item._id}>
            <td><input
                onChange={event => {
                    let key = item.dataID
                    let date = moment(item.date, [moment.ISO_8601,]).format('YYYY-MM-DD')
                    let val = {"dataID": key, "type": item.type, "date": date}
                    let objkey = reportobject
                    if (event.target.checked) {
                        objkey[key] = val
                        setreportobject(objkey);
                    } else if (!event.target.checked) {
                        delete objkey[key]
                        setreportobject(objkey);
                    }
                }}
                className="userdetailscheckbox"
                type="checkbox"
                id="checkbox"
                //defaultChecked={oneDayTickStatus}
            /></td>
            <td>{moment(item.date, [moment.ISO_8601,]).format('YYYY-MM-DD')}</td>
            <td>{item.type}</td>
            <td>{item.creatorFirstName + " " + item.creatorLastName}</td>
        </tr>))
    }

    function preparetatigexpertstundentabledata(tabledata) {
        return tabledata?.map((item) => (<tr key={item.experten}>
            <td>{item.experten}</td>
            <td>{item.anzahl}</td>
            <td>{item.stunden}</td>
        </tr>))
    }

    function preparetatiganwesentabledata(tabledata) {
        return tabledata?.map((item) => (<tr key={item.id}>
            <td>{item.firstName + " " + item.lastName}</td>
        </tr>))
    }

    function preparetatigmaterialtabledata(tabledata) {
        return tabledata?.map((item) => (<tr key={item.id}>
            <td>{item.position}</td>
            <td>{item.kurzText}</td>

            <td>{item.menge}</td>
            <td>{item.einheit}</td>
            <td>{item.teilmas}</td>
        </tr>))
    }

    function preparetatigdevicetabledata(tabledata) {
        return tabledata?.map((item) => (<tr key={item.id}>
            <td>{item.name}</td>
        </tr>))
    }

    function preparestorungtabledata(tabledata) {
        return tabledata?.map((item) => (<tr key={item.taetigkeitID}>
            <td>{item.titel}</td>
        </tr>))
    }

    function multipletatig(completetatigdata) {

        return completetatigdata.map((i) =>
            <Col key={i}>
                <Row>
                    <label
                        className="handwai-text-label-main"
                        style={{textDecorationLine: "underline"}}>Bauleistung: {moment(i.tatigleistungsubersicht).format('DD.MM.YYYY')}</label>
                </Row>
                <Row>
                    <Col style={{padding: 0}}>
                        <label
                            className="handwai-text-label-main">Anwensenheit: {i.tatiganwensenheit}</label>


                    </Col>
                    <Col>
                        <label
                            className="handwai-text-label-main">Innen-Temperatur: {(Math.round((i.tatiginnenwetter) * 10) / 10).toString().replace(".", ",")}</label>
                    </Col>
                    <Col>
                        <label
                            className="handwai-text-label-main">Außen-Temperatur: {(Math.round((i.tatigaussenwetter) * 10) / 10).toString().replace(".", ",")}</label>
                    </Col>

                    <Col>
                        <label
                            className="handwai-text-label-main">Details: {i.tatigdetailswetter}</label>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <label className="handwai-text-label-main">Anwesenheit Vor-Ort</label>
                </Row>
                <Row>
                    <Col style={{padding: 0}}>
                        <table id='tatigexpertstundentable'
                               className='table'>
                            <thead>
                            <tr>
                                <th data-sortable='true' data-searchable='true'>
                                    Rolle
                                </th>
                                <th data-sortable='true' data-searchable='true'>
                                    Anzahl
                                </th>
                                <th data-sortable='true' data-searchable='true'>
                                    Gesamtstunden
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {preparetatigexpertstundentabledata(i.tatigexpertstundentabledata)}
                            </tbody>
                        </table>
                    </Col>
                    <Col>
                        <table id='tatiganwesentable'
                               className='table'>
                            <thead>
                            <tr>
                                <th data-sortable='true' data-searchable='true'>
                                    Auftraggeber
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {preparetatiganwesentabledata(i.tatiganwesentabledata)}</tbody>
                        </table>
                    </Col>
                </Row>

                <Row>
                    <label className="handwai-text-label-main">Tätigkeit</label>
                </Row>

                <Row className={"tatigkeiten-div-scroll"}>{multipletatigimages(i.imagesdata)}</Row>


                <Row>
                    <label className="handwai-text-label-main">Material</label>
                </Row>
                <Row>
                    <table id='tatigmaterialtable'
                           className='table'>
                        <thead>
                        <tr>
                            <th data-sortable='true' data-searchable='true'>
                                Position
                            </th>
                            <th data-sortable='true' data-searchable='true'>
                                Beschreibung
                            </th>

                            <th data-sortable='true' data-searchable='true'>
                                Menge
                            </th>
                            <th data-sortable='true' data-searchable='true'>
                                Einheit
                            </th>
                            <th data-sortable='true' data-searchable='true'>
                                Teilaufmaß
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {preparetatigmaterialtabledata(i.tatigmaterialtabledata)}
                        </tbody>
                    </table>
                </Row>
                <Row>
                    <label className="handwai-text-label-main">Betriebsmittel</label>
                </Row>
                <Row>
                    <table id='tatigdevicetable'
                           className='table'>
                        <thead>
                        <tr>
                            <th data-sortable='true' data-searchable='true'>
                                Name
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {preparetatigdevicetabledata(i.tatigdevicetabledata)}
                        </tbody>
                    </table>
                </Row>

                <Row>
                    <label className="handwai-text-label-main">Störung(en)</label>
                </Row>
                <Row>
                    <table id='storungtable'
                           className='table'>
                        <thead>
                        <tr>
                            <th data-sortable='true' data-searchable='true'>
                                Titel
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {preparestorungtabledata(i.tatigStoerung)}
                        </tbody>
                    </table>
                </Row>
                <br/>


            </Col>)
    }


    function multipletatigimages(tatigimagedata) {
        return tatigimagedata.map((j) =>
            <>
                <Row style={{width: "100%"}} key={j}>

                    <br/>
                    <br/>
                    <Col md={4}>
                        <TagesTatigVerortung
                            verortungImages={j.tatigverortungimages}
                        />
                    </Col>
                    {/*<Col md={}/>*/}
                    <Col md={7}>
                        <TagesTaetigkeiten
                            taetigkeitenData={j.description}
                            taetigkeitenImages={j.tatigkeitenimages}
                        />
                    </Col>
                    {/*<Col/>*/}
                </Row>
                <br/>
                <br/>
            </>
        )

    }


    function addExpertenTable(doc, tabledata) {
        let head = [];
        head.push("Rolle");
        head.push("Anzahl");
        head.push("Gesamtstunden");

        let body = [];

        tabledata.forEach((object) => {
            let onerowdata = []
            onerowdata.push(object.experten);
            onerowdata.push(object.anzahl);
            onerowdata.push(object.stunden);
            body.push(onerowdata)
        });


        doc.autoTable({

            margin: 25,
            startY: 90,
            theme: 'grid',
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
            head: [head],
            body: body
        });
    }

    function addTatigAnwesenTable(doc, tabledata) {

        let tableHead = [];
        tableHead.push("Auftraggeber");

        let tableBody = [];

        tabledata.forEach((object) => {
            let onerowdata = []
            onerowdata.push(object.firstName + " " + object.lastName);
            tableBody.push(onerowdata)
        });


        doc.autoTable({
            margin: 25,
            theme: 'grid',
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
            head: [tableHead],
            body: tableBody
        });
    }

    function addTatigMaterialTable(doc, tabledata) {


        let head = [];
        head.push("Position");
        head.push("Beschreibung");

        head.push("Einheit");
        head.push("Teilaufmaß");
        head.push("Menge");


        let body = [];

        tabledata.forEach((object) => {
            let onerowdata = []
            onerowdata.push(object.position);
            onerowdata.push(object.kurzText);
            let unit = object.einheit
            if (unit === "㎡" || unit === "m²") {
                unit = "m²"
            } else if (unit === "㎥" || unit === "m³") {
                unit = "m³"
            }
            onerowdata.push(unit);
            onerowdata.push(object.teilmas);
            onerowdata.push(object.menge);
            body.push(onerowdata)
        });

        doc.autoTable({
            margin: 25,
            startY: 35,
            theme: 'grid',
            headStyles: {
                cellHeight: "auto",
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
            head: [head],
            body: body
        });
    }

    function addTatigDeviceTable(doc, tabledata) {
        let head = [];
        head.push("Name");

        let body = [];

        tabledata.forEach((object) => {
            let onerowdata = []
            onerowdata.push(object.name);
            body.push(onerowdata)
        });

        //body = tabledata

        doc.autoTable({
            startY: doc.lastAutoTable.finalY + 25,
            theme: 'grid',
            margin: 25,
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
            head: [head],
            body: body
        });
    }

    function addTatigStoerungTable(doc, tabledata) {
        let head = [];
        head.push("Titel");

        let body = [];

        tabledata.forEach((stoerung) => {
            let onerowdata = []
            onerowdata.push(stoerung.titel);
            body.push(onerowdata)
        });
        doc.autoTable({
            startY: doc.lastAutoTable.finalY + 25,
            theme: 'grid',
            margin: 25,
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
            head: [head],
            body: body
        });
    }

    async function imagesetverortung(images, doc) {
        printImages(doc, "Verortung der Tätigkeit(en)", images)
    }

    function printImages(doc, mainDesc, images) {
        if (mainDesc !== "Tätigkeit(en)") {
            for (let i = 0; i < images.length; i++) {
                let x = 25
                let y = 40
                let MAX_WIDTH = 180;
                let MAX_HEIGHT = 280
                ///////////////////////
                doc.addPage();
                doc.setFontSize(16);
                doc.text(mainDesc, 25, 30);
                if (mainDesc === "Tätigkeit(en)") {
                    doc.text("Beschreibung der Tätigkeit(en):", 25, 45, "left")
                    doc.text(images[i].description, 25, 55, {maxWidth: 160})
                    doc.addPage();
                    doc.text("Bild(er) der Taetigkeit(en)", 25, 30);
                }
                let width = images[i].width;
                let height = images[i].height;
                MAX_WIDTH = 170;
                MAX_HEIGHT = 240
                //MAX_HEIGHT = 225 - 2 * (Math.floor(doc.getTextWidth(images[i].description)) / 160);
                //y = 1 + y + 2 * (Math.floor(doc.getTextWidth(images[i].description)) / 160)

                //if(width>height){[height,width] = [width,height]}

                if (width > height) {
                    MAX_HEIGHT = 170;
                    MAX_WIDTH = 240

                    height = height * (MAX_WIDTH / width);
                    width = MAX_WIDTH;
                } else {
                    if (height > MAX_HEIGHT & height > width) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                let deg = null
                if (images[i].width > images[i].height) {
                    y = y + MAX_WIDTH - height
                    x = x + MAX_HEIGHT
                    //y = y+MAX_WIDTH
                    deg = 90
                }
                let link = images[i].link
                if (!link.includes("https")) {
                    link.replace("http", "https")
                }
                doc.addImage(link, 'JPEG', x, y, width, height, null, "FAST", deg);
                ///////////////////////
            }
        }

        if (mainDesc === "Tätigkeit(en)") {
            let headline = false
            let group = images
            for (let i = 0; i < group.length; i++) {
                let x = 25
                let y = 40
                let MAX_WIDTH = 180;
                let MAX_HEIGHT = 280
                ///////////////////////
                doc.addPage();
                doc.setFontSize(16);
                if (headline) {
                    doc.text("Bild(er) der Taetigkeit(en)", 25, 30)
                }
                //doc.text("Beschreibung Tätigkeit(en)", 25, 30);
                if (mainDesc === "Tätigkeit(en)") {

                    if (i === 0) {
                        headline = true
                        doc.setFontSize(16);
                        doc.text("Beschreibung der Tätigkeit(en):", 25, 30, "left")
                        //doc.text("Beschreibung:", 25, 45, "left")
                        doc.text(group[i].description, 25, 45, {maxWidth: 160})
                        doc.addPage();
                        doc.text("Bild(er) der Taetigkeit(en)", 25, 30);
                    }

                    //doc.setFontSize(16);
                    //doc.text("Beschreibung Tätigkeit(en)", 25, 30);
                }
                let width = group[i].width;
                let height = group[i].height;
                MAX_WIDTH = 170;
                MAX_HEIGHT = 240
                //MAX_HEIGHT = 225 - 2 * (Math.floor(doc.getTextWidth(images[i].description)) / 160);
                //y = 1 + y + 2 * (Math.floor(doc.getTextWidth(images[i].description)) / 160)

                //if(width>height){[height,width] = [width,height]}

                if (width > height) {
                    MAX_HEIGHT = 170;
                    MAX_WIDTH = 240

                    height = height * (MAX_WIDTH / width);
                    width = MAX_WIDTH;
                } else {
                    if (height > MAX_HEIGHT & height > width) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                let deg = null
                if (group[i].width > group[i].height) {
                    y = y + MAX_WIDTH - height
                    x = x + MAX_HEIGHT
                    //y = y+MAX_WIDTH
                    deg = 90
                }

                let link = images[i].link
                if (!link.includes("https")) {
                    link.replace("http", "https")
                }
                doc.addImage(link, 'JPEG', x, y, width, height, null, "FAST", deg);
                ///////////////////////
            }

        }
    }

    async function imagesettatigkeitenmodified(images, doc) {
        let imagesdescription = images.description
        let oldarrayofimage = JSON.parse(JSON.stringify(images.timageurls))
        oldarrayofimage.forEach((object) => {
            object["description"] = imagesdescription
        })
        printImages(doc, "Tätigkeit(en)", oldarrayofimage)
    }

    async function addVerortungImages(doc, data) {
        //data.forEach(images => {
        for (let images of data) {
            await imagesetverortung(images.vimageurls, doc)
            await imagesettatigkeitenmodified(images, doc)
        }
    }

    async function createTReport(reportDetails) {
        let reportData = pdfData
        let s = 0
        const doc = new jsPDF({orientation: "p", lineHeight: 1.5});
        doc.addFileToVFS("calibri-bold-bold.ttf", font)
        doc.addFont('calibri-bold-bold.ttf', 'calibri-bold', 'bold');
        doc.setFont("Calibri", "normal", "");
        doc.setFontSize(18)
        doc.text("Tagesbericht", 25, 30, "left",);
        const tagesberichtTextWidth = doc.getTextWidth("Tagesbericht");
        doc.line(25, 31, 25 + tagesberichtTextWidth, 31)

        //if (reportDetails.type === "post") {
        doc.setFont('calibri-bold', 'bold')
        doc.setFontSize(13.5)
        doc.text("Empfänger:", 25, 42, "left",);
        doc.setFontSize(12)
        doc.setFont("Calibri", "normal", "");
        doc.text(reportDetails.anschrift, 25, 53, "left",);
        s = 40
        //doc.addPage()
        //}

        doc.setFontSize(16)
        doc.text("Bauvorhaben: " + projectName, 25, 58 + s, "left",);
        doc.setFontSize(14)
        doc.setLanguage("de-DE")

        let tatiginitialparatextone = 'Der Auftragnehmer hat auf Verlangen Bautagesberichte zu führen und dem Auftraggeber täglich zu übergeben. Sie müssen alle Angaben enthalten, die für die Ausführung und Abrechnung des Auftrages von Bedeutung sein können.'
        doc.text(tatiginitialparatextone, 25, 117, {maxWidth: 160})

        let tatiginitialparatexttwo = "Dies sind insbesondere:"
        doc.text(tatiginitialparatexttwo, 25, 145, {maxWidth: 160})

        let textarray = [
            "•  Beginn und Ende der täglichen Arbeitszeit,",
            "•  Witterung (Temperaturen, Niederschlagsmengen, Luftfeuchtigkeit)",
            "•  Anzahl und Qualifikation der auf der Baustelle beschäftigten Arbeitskräfte",
            "•  eingesetzte Nachunternehmer/andere Unternehmer",
            "•  Anzahl und Art der eingesetzten Großgeräte sowie deren Zu- und Abgang",
            "•  Anlieferung von Hauptbaustoffen",
            "•  Art, Umfang und Ort (Station, Bauteil) der geleisteten Arbeiten mit den",
            "    wesentlichen Angaben über den Baufortschritt (Beginn und Ende von",
            "    Leistungen größeren Umfanges, Betonierungszeiten und dergleichen)",
            "•  Behinderung und Unterbrechung der Ausführung",
            "•  Arbeitseinstellung mit Angabe der Gründe",
            "•  Unfälle und sonstige wichtige Vorkommnisse."
        ]
        let y = 155
        //let g = 400
        let z = 0
        textarray.forEach((i) => {
            doc.text(i, 30, y, {maxWidth: 160})
            z = Math.floor(doc.getTextWidth(i) / 160)
            y = y + 8 + z * 8
        })

        for (let k of reportData) {
            doc.addPage();
            doc.setFontSize(16);
            doc.setTextColor(0, 0, 0)

            doc.text("Bauleistung: " + moment(k.tatigleistungsubersicht).format('DD.MM.YYYY'), 25, 30)
            doc.text("Witterung", 25, 45)
            doc.setFontSize(12);
            let innertemp = (Math.round((k.tatiginnenwetter) * 10) / 10).toString().replace(".", ",")
            doc.text("Innen-Temperatur: " + innertemp, 25, 50);
            let outertemp = (Math.round((k.tatigaussenwetter) * 10) / 10).toString().replace(".", ",")
            doc.text("Außen-Temperatur: " + outertemp, 25, 55);
            doc.text("Wetter Details: " + k.tatigdetailswetter, 25, 60);


            doc.setFontSize(16);
            doc.text("Besetzung Baustelle", 25, 70)
            doc.setFontSize(12);
            doc.text("Start Anwesenheit: " + k.tatiganwensenheit.split(" - ")[0] + " Uhr", 25, 75);
            doc.text("Ende Anwesenheit: " + k.tatiganwensenheit.split(" - ")[1] + " Uhr", 25, 80);

            addExpertenTable(doc, k.tatigexpertstundentabledata)
            addTatigAnwesenTable(doc, k.tatiganwesentabledata)
            await addVerortungImages(doc, k.imagesdata);
            doc.addPage();
            doc.setFontSize(16);
            doc.text("Material", 25, 30)
            addTatigMaterialTable(doc, k.tatigmaterialtabledata)
            doc.setFontSize(16);
            doc.text("Betriebsmittel", 25, doc.lastAutoTable.finalY + 20);
            addTatigDeviceTable(doc, k.tatigdevicetabledata)
            doc.setFontSize(11);
            doc.setTextColor(0, 0, 0)


            doc.setFontSize(16);
            doc.text("Störung(en)", 25, doc.lastAutoTable.finalY + 20);
            addTatigStoerungTable(doc, k.tatigStoerung)
            doc.setFontSize(11);
            doc.setTextColor(0, 0, 0)
        }

        doc.setFontSize(10);
        let pdfname = moment().format("YYYYMMDD") + "_TAR_" + projectName
        for (let i = 1; i <= doc.getNumberOfPages(); i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text(25, doc.internal.pageSize.height - 10, pdfname);
            doc.text((doc.internal.pageSize.width / 2) - 3, doc.internal.pageSize.height - 10, "Seite: " + i.toString() + " von " + doc.getNumberOfPages());
        }
        if (reportDetails.type === "downloadPDF")
        {
            doc.save(pdfname + ".pdf")
            return {status: "200"}
        }
        else {
            return {
                status: "200",
                pdf: doc.output("datauristring"),
                pdfName: pdfname,
                savePdf: doc.output("datauristring")
            }
        }

    }

    return (<div className="handwai-dark">
            <div style={{
                width: '100%', overflow: 'auto', overflowX: 'hidden',
            }}>
                <Row
                    className="handwai-text-label-normal">
                    <Col/>
                    <Col/>
                    <Col/>
                    <Col>

                        <br/>

                        <div style={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'
                        }}>

                            &nbsp;
                            &nbsp;
                        </div>
                    </Col>
                </Row>

                <br/>
                <br/>

                <br/>


                {(!reportView && !acceptState) &&
                <>
                    <Row>
                        <Col sm={1}/>


                        <Col sm={10}>

                            <Row>
                                <Form id="dateselect" className={"container-fluid"}>
                                    <Row>


                                        <Col style={{paddingLeft: 0}} sm={3}>


                                            <Select
                                                options={options}
                                                onChange={async (e) => {
                                                    setProjectID(e.value)
                                                    setProjectName(e.label)
                                                }
                                                }
                                            />
                                        </Col>
                                        <Col sm={1}/>

                                        <Col sm={0.5}>

                                            <input
                                                //disabled={!isProjectAvailable()}
                                                onChange={event => {
                                                    setOneDayTickStatus(event.target.checked)
                                                    if (event.target.checked) {
                                                        setEndDate("")
                                                    } else if (!event.target.checked) {
                                                        setEndDate('')
                                                    }
                                                }}
                                                className="userdetailscheckbox"
                                                type="checkbox"
                                                id="checkbox"
                                                defaultChecked={oneDayTickStatus}
                                            />
                                        </Col>
                                        <Col sm={1}>
                                            <Form.Label className={"aufmasText"}>
                                                Ein Tag
                                            </Form.Label>
                                        </Col>

                                        <Col style={{className: "col-md"}}>

                                            <Form.Group controlId="formGroupSingleDate">

                                                <Form.Control
                                                    //disabled={!isOneDayDateActive()}
                                                    type="date"
                                                    className="handwai-input"
                                                    //style={addWidth555}
                                                    onChange={(event) => {
                                                        let eventValue = event.target.value;
                                                        let date = moment(eventValue).format("DD-MM-YYYY")
                                                        setOneDayDate(date);
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col style={{className: "col-md"}}>

                                            <Form.Group controlId="formGroupEndDate">
                                                <Form.Control
                                                    disabled={oneDayTickStatus}
                                                    type="date"
                                                    className="handwai-input"
                                                    //style={addWidth555}
                                                    onChange={(event) => {
                                                        let eventValue = event.target.value;
                                                        let date = moment(eventValue).format("DD-MM-YYYY")
                                                        setEndDate(date);
                                                    }}
                                                />
                                            </Form.Group>

                                        </Col>;
                                        <Col sm={1}/>

                                        <Col style={{className: "col-md", textAlign: "Right"}}>
                                            <Button
                                                disabled={!oneDayDate && !endDate}
                                                onClick={async () => {
                                                    let apiBody = {
                                                        projectName: projectName,
                                                        projectID: projectID,
                                                        startDate: oneDayDate,
                                                        endDate: endDate
                                                    }
                                                    let result = await getreportselectiontabledata(apiBody)
                                                    //let result = []
                                                    setreportselecttableonebody(result)

                                                }
                                                }
                                                className="handwai-btn-create"
                                                variant="success"
                                            >
                                                Anzeigen
                                            </Button>
                                        </Col>

                                    </Row>

                                </Form>
                            </Row>

                            <Row>
                                <table id='reportselecttableone'
                                       className='table'>
                                    <thead>
                                    <tr>
                                        <th data-sortable='true' data-searchable='true'>
                                            Auswahl
                                        </th>
                                        <th data-sortable='true' data-searchable='true'>
                                            Datum
                                        </th>
                                        <th data-sortable='true' data-searchable='true'>
                                            Typ
                                        </th>
                                        <th data-sortable='true' data-searchable='true'>
                                            Ersteller
                                        </th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {preparereportselectiontabledata(reportselecttableonebody)}
                                    </tbody>
                                </table>
                            </Row>

                            <Row>

                                <Button
                                    onClick={async () => {
                                        await getcompletetagesreportdata(reportobject)
                                    }
                                    }
                                    className="handwai-btn-create"
                                    variant="success"
                                >
                                    Erstellen
                                </Button>


                            </Row>

                        </Col>

                    </Row>

                    <br/>
                    <Row>
                        <Col sm={1}/>
                        <Col sm={10}>
                            <div className="horizontal-line"></div>
                        </Col>
                    </Row>
                </>
                }


                <Row>
                    <Col sm={1}/>
                    <Col sm={10} style={{padding: 0}}>
                        {
                            multipletatig(maintatigdataarray)
                        }

                        {
                            <TagesButtonComponent
                                pdfAddress={pdfAddress}
                                tagesState={tagesState}
                                setTagesState={setTagesState}
                                auftraggeberList={auftraggeberList}
                                metaID={metaID}
                                setMetaID={setMetaID}
                                tagesComponents={tagesComponents}
                                setTagescomponents={setTagescomponents}
                                acceptState={acceptState}
                                setAcceptState={setAcceptState}
                                reportViewWithoutLogin={props.reportViewWithoutLogin}
                                orgID={sessionStorage.getItem("org")}
                                projectID={projectID}
                                handleShow={handleShow}
                                setHandleShow={setHandleShow}
                                reportView={reportView}
                                pdfData={pdfData}
                                maintatigdataarray={maintatigdataarray}
                                reportDetails={reportDetails}
                                setReportDetails={setReportDetails}
                                createTReport={createTReport}
                                disablePDFButton={disablePDFButton}
                                projectData={projectData}
                            />
                            }

                    </Col>


                </Row>


                <br/>
                <Row>
                    <Col/>
                    <Col sm={2} md={2}>
                    </Col>
                    <Col sm={2} md={2}/>
                    <Col sm={7} md={7}>
                    </Col>
                    <Col/>
                </Row>
            </div>
            <br/>
            <br/>

            <AppCommonReportComponent
                createTReport={createTReport}
                handleShow={handleShow}
                setHandleShow={setHandleShow}
                type={"Tages"}
                reportDetails={reportDetails}
                pdfData={pdfData}
                tagesData={maintatigdataarray}
                //tagesberichtDataID={}
                projectData={projectData}
                metaData={metaData}
            />
        </div>

    );
}

export default memo(TagesberichtComponent);